<div class="d-flex flex-column" [class.h-100]="settings?.stretchVertical">
  @if (settings?.itemAlignment === 'between') {
    <div [class.p-2]="hasBackgroundOrBorderStyle">
      <ng-template *ngTemplateOutlet="headingsPair"></ng-template>
    </div>
  }
  @if (hasItemAlignedTopOrBetween && !hasNoItem) {
    <div class="mb-2" #itemContainer>
      <ng-content></ng-content>
    </div>
  }
  <div
    class="d-flex flex-column flex-grow-1"
    [ngClass]="{
      'px-2 pb-2 pt-lg-2': hasBackgroundOrBorderStyle,
      'pt-2': hasBackgroundOrBorderStyle && hasNoItem,
    }"
  >
    @if (!(settings?.itemAlignment === 'between')) {
      <div>
        <ng-template *ngTemplateOutlet="headingsPair"></ng-template>
      </div>
    }
    @if (content?.text?.text?.value) {
      <wl-rich-text-wrapper [field]="content?.text?.text">
        <div
          [class.text-center]="content?.centerText"
          [ngClass]="['mb-2', content?.text?.style]"
        ></div>
      </wl-rich-text-wrapper>
    }
    @if (settings?.stretchVertical) {
      <div class="flex-grow-1"></div>
    }
    <div class="d-flex flex-wrap" [ngClass]="buttonsAlignment">
      @if (content?.buttons?.primary?.link; as primaryLink) {
        <a
          *wlGenericLink="primaryLink; extras: navigationExtras"
          [ngClass]="['mb-2', content?.buttons?.primary?.style]"
          [class.d-block]="isInSmallCol"
          [class.w-100]="isInSmallCol"
          [class.me-2]="
            !isInSmallCol &&
            !content?.buttons?.alignVertically &&
            content?.buttons?.secondary?.link?.href
          "
          trackImpression="button-impression"
          [trackImpressionName]="primaryLink.text"
          [trackImpressionInfo]="{
            componentName: 'basic-content',
          }"
        ></a>
      }
      @if (content?.buttons?.secondary?.link; as secondaryLink) {
        <a
          *wlGenericLink="secondaryLink; extras: navigationExtras"
          [ngClass]="['mb-2 mt-0', content?.buttons?.secondary?.style]"
          [class.d-block]="isInSmallCol"
          [class.w-100]="isInSmallCol"
          trackImpression="button-impression"
          [trackImpressionName]="secondaryLink?.text"
          [trackImpressionInfo]="{
            componentName: 'basic-content',
          }"
        ></a>
      }
    </div>
    @if (
      content?.microcopy?.text?.value && content?.microcopy?.text;
      as microcopyText
    ) {
      <p
        *scText="microcopyText"
        [ngClass]="[content?.microcopy?.style, 'mb-0']"
        [class.text-center]="content?.centerText"
      ></p>
    }
  </div>
</div>

<ng-template #headingsPair>
  <div class="d-flex mb-1" [class.justify-content-center]="content?.centerText">
    <wl-basic-content-partial-heading
      [heading]="content?.heading"
      [size]="headingSize"
      [icon]="settings?.icon"
      [showIcon]="showIconInHeader"
      [centerText]="content?.centerText"
    >
    </wl-basic-content-partial-heading>
  </div>
  @if (
    content?.subheading?.text?.value && content?.subheading?.text;
    as subheadingText
  ) {
    <p
      *scText="subheadingText"
      class="subheading"
      [class.text-center]="content?.centerText"
      [ngClass]="[
        content?.subheading?.style,
        subheadingSize,
        settings?.itemAlignment === 'between' ? 'mb-0' : 'mb-1',
      ]"
    ></p>
  }
</ng-template>
